export var getRandomString = function () { return Math.random().toString(36).slice(2, 18); };
